
<div style="overflow:hidden;text-overflow:ellipsis;" [id]="id">
    <span [ngbPopover]="value" container="body" popoverClass="CXoneMgtPopover" [placement]="this.getPopoverPosition()" triggers="mouseenter:mouseleave" [openDelay]="400"
          [disablePopover]="params.value === null || params.value === '' || this.hidePopover() " class="textContent" [innerHTML]="value | boldText:searchFilter:minSearchLength" >
    </span>
</div>
